export const defaultAudio = {
  sound: true,
  music: true,
  volume: "0.5",
}
export const defaultAutoConfigs = {
  numberOfBets: "0",
  onWinIncrease: false,
  onWinPercent: "0",
  onLossIncrease: false,
  onLossPercent: "0",
  stopOnProfit: "0.00",
  stopOnLoss: "0.00",
}
export const defaultGameInfo = {
  user_name: "",
  user_id: "",
  currency: "",
  balance: "",
  precision: 2,
  maxBet: 100,
  minBet: "0.10",
  coeffs: [],
}

export const defaultBetInfo = {
  balance: "",
  betAmount: "",
  bet_id: "",
  mode: "",
  rolled: [],
  rows: "",
  type: "",
  winAmount: "",
  winCoeff: "",
}
export const defaultSeeds = {
  client_seed: "",
  server_seed_SHA256: "",
  next_server_seed_SHA256: "",
  nonce: 0,
  old_client_seed: "",
  old_servr_seed: "",
  old_erver_seed_SHA256: "",
  old_nonce: 0,
}
